<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2">Abbreviations</h1>
<table>
<tbody>
<tr>
<td class="col25"><p class="t-left"><em>ABD</em></p></td>
<td class="col70"><p class="t-left"><em>Anchor Bible Dictionary</em>. Edited by David Noel Freedman. 6 vols. New York: Doubleday, 1992</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>AEL</em></p></td>
<td class="col70"><p class="t-left"><em>Ancient Egyptian Literature</em>. Miriam Lichtheim. 3 vols. Berkeley: University of California Press, 1971–1980</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ANEP</em></p></td>
<td class="col70"><p class="t-left"><em>The Ancient Near East in Pictures Relating to the Old Testament</em>. 2nd ed. Edited by James B. Pritchard. Princeton: Princeton University Press, 1994</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ANET</em></p></td>
<td class="col70"><p class="t-left"><em>Ancient Near Eastern Texts Relating to the Old Testament</em>. Edited by James B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">BAGD</p></td>
<td class="col70"><p class="t-left">Bauer, Walter, William F. Arndt, F. Wilbur Gingrich, and Frederick W. Danker. <em>Greek-English Lexicon of the New Testament and Other Early Christian Literature</em>. 2nd ed. Chicago: University of Chicago Press, 1979</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">BBRSup</p></td>
<td class="col70"><p class="t-left">Bulletin for Biblical Research, Supplements</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">BDB</p></td>
<td class="col70"><p class="t-left">Brown, Francis, S. R. Driver, and Charles A. Briggs. <em>A Hebrew and English Lexicon of the Old Testament</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>Bib</em></p></td>
<td class="col70"><p class="t-left"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>BiBh</em></p></td>
<td class="col70"><p class="t-left"><em>Bible Bhashyam</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">BibOr</p></td>
<td class="col70"><p class="t-left">Biblica et Orientalia</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">BKAT</p></td>
<td class="col70"><p class="t-left">Biblischer Kommentar: Altes Testament</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>BR</em></p></td>
<td class="col70"><p class="t-left"><em>Biblical Research</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>BSac</em></p></td>
<td class="col70"><p class="t-left"><em>Bibliotheca Sacra</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>BT</em></p></td>
<td class="col70"><p class="t-left"><em>The Bible Translator</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">CAT</p></td>
<td class="col70"><p class="t-left">Commentaire de l’Ancien Testament</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>CBQ</em></p></td>
<td class="col70"><p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">ConBOT</p></td>
<td class="col70"><p class="t-left">Coniectanea Biblica, Old Testament Series</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>DOTWPW</em></p></td>
<td class="col70"><p class="t-left"><em>Dictionary of the Old Testament: Wisdom, Poetry and Writings.</em> Edited by Scott C. Jones, Tremper Longman III, and Peter Enns. Downers Grove, IL: InterVarsity Press, 2008</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">EBC</p></td>
<td class="col70"><p class="t-left">Expositor’s Bible Commentary. Edited by Frank E. Gaebelein. 12 vols. Grand Rapids: Zondervan, 1979–1988</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>EvQ</em></p></td>
<td class="col70"><p class="t-left"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">GKC</p></td>
<td class="col70"><p class="t-left"><em>Gesenius’ Hebrew Grammar.</em> Ed. E. Kautzsch. Tr. A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>GUOST</em></p></td>
<td class="col70"><p class="t-left"><em>Glasgow University Oriental Society Transactions</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>HALOT</em></p></td>
<td class="col70"><p class="t-left"><em>The Hebrew and Aramaic Lexicon of the Old Testament</em>. Ludwig Koehler, Walter Baumgartner, and Johann J. Stamm. Translated and edited under the supervision of Mervyn E. J. Richardson. 4 vols. Leiden: Brill, 1994–1999</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">HAT</p></td>
<td class="col70"><p class="t-left">Handbuch zum Alten Testament</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>HeyJ</em></p></td>
<td class="col70"><p class="t-left"><em>Heythrop Journal</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>HTR</em></p></td>
<td class="col70"><p class="t-left"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>HUCA</em></p></td>
<td class="col70"><p class="t-left"><em>Hebrew Union College Annual</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>IBHS</em></p></td>
<td class="col70"><p class="t-left"><em>An Introduction to Biblical Hebrew Syntax</em>. Bruce K. Waltke and Michael O’Connor. Winona Lake, IN: Eisenbrauns, 1990</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">ICC</p></td>
<td class="col70"><p class="t-left">International Critical Commentary</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ISBE</em></p></td>
<td class="col70"><p class="t-left"><em>International Standard Bible Encyclopedia</em>. Edited by Geoffrey W. Bromiley. 4 vols. Grand Rapids: Eerdmans, 1979–1988</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>JAOS</em></p></td>
<td class="col70"><p class="t-left"><em>Journal of the American Oriental Society</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>JBL</em></p></td>
<td class="col70"><p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>JETS</em></p></td>
<td class="col70"><p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">JM</p></td>
<td class="col70"><p class="t-left">P. Joüon and T. Muraoka, <em>A Grammar of Biblical Hebrew</em>. Editrice Pontificio Istituto Biblico. Rom, 1911</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>JNSL</em></p></td>
<td class="col70"><p class="t-left"><em>Journal of Northwest Semitic Languages</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">JSOTSup</p></td>
<td class="col70"><p class="t-left">Journal of the Society of Old Testament Supplement Series</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>JSS</em></p></td>
<td class="col70"><p class="t-left"><em>Journal of Semitic Studies</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">LUÅ</p></td>
<td class="col70"><p class="t-left">Lunds universitets årsskrift</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">LXX</p></td>
<td class="col70"><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">MT</p></td>
<td class="col70"><p class="t-left">Masoretic Text</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">NAC</p></td>
<td class="col70"><p class="t-left">New American Commentary</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>NBD</em></p></td>
<td class="col70"><p class="t-left"><em>New Bible Dictionary</em>. Edited by D. R. W. Wood, Howard Marshall, J. D. Douglas, and N. Hillyer. 3rd ed. Downers Grove, IL: InterVarsity Press, 1996</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">NCBC</p></td>
<td class="col70"><p class="t-left">New Century Bible Commentary</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>NIB</em></p></td>
<td class="col70"><p class="t-left"><em>The New Interpreter’s Bible</em>. Edited by Leander E. Keck. 12 vols. Nashville: Abingdon, 1994–2004</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">NICOT</p></td>
<td class="col70"><p class="t-left">New International Commentary on the Old Testament</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>NIDOTTE</em></p></td>
<td class="col70"><p class="t-left"><em>New International Dictionary of Old Testament Theology and Exegesis</em>. Edited by Willem A. VanGemeren. 5 vols. Grand Rapids: Zondervan, 1997</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">OTL</p></td>
<td class="col70"><p class="t-left">Old Testament Library</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">OTS</p></td>
<td class="col70"><p class="t-left">Old Testament Studies</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>OtSt</em></p></td>
<td class="col70"><p class="t-left"><em>Oudtestamentische Studiën</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>RB</em></p></td>
<td class="col70"><p class="t-left"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">SBL</p></td>
<td class="col70"><p class="t-left">Society of Biblical Literature</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>SJT</em></p></td>
<td class="col70"><p class="t-left"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">Syr.</p></td>
<td class="col70"><p class="t-left">Syriac</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">Targ.</p></td>
<td class="col70"><p class="t-left">Targum</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>TDOT</em></p></td>
<td class="col70"><p class="t-left"><em>Theological Dictionary of the Old Testament</em>. Edited by G. Johannes Botterweck and Helmer Ringgren. Translated by John T. Willis et al. 8 vols. Grand Rapids: Eerdmans, 1974–2006</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>TLOT</em></p></td>
<td class="col70"><p class="t-left"><em>Theological Lexicon of the Old Testament</em>. Edited by Ernst Jenni, with assistance from Claus Westermann. Translated by Mark E. Biddle. 3 vols. Peabody, MA: Hendrickson, 1997</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>TLZ</em></p></td>
<td class="col70"><p class="t-left"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">TOTC</p></td>
<td class="col70"><p class="t-left">Tyndale Old Testament Commentaries</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>TWOT</em></p></td>
<td class="col70"><p class="t-left"><em>Theological Wordbook of the Old Testament</em>. Edited by R. Laird Harris, Gleason L. Archer Jr., and Bruce K. Waltke. 2 vols. Chicago: Moody Press, 1980</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>TynBul</em></p></td>
<td class="col70"><p class="t-left"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>VT</em></p></td>
<td class="col70"><p class="t-left"><em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">VTSup</p></td>
<td class="col70"><p class="t-left">Supplement to Vetus Testamentum</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">Vulg.</p></td>
<td class="col70"><p class="t-left">Vulgate</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">WBC</p></td>
<td class="col70"><p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>WIANE</em></p></td>
<td class="col70"><p class="t-left"><em>Wisdom in Israel and in the Ancient Near East</em>. Edited by M. Noth and D. Winton Thomas. Leiden: Brill, 1969</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">WMANT</p></td>
<td class="col70"><p class="t-left">Wissenschaftliche Monographien zum Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>WTJ</em></p></td>
<td class="col70"><p class="t-left"><em>Westminster Theological Journal</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>WWis</em></p></td>
<td class="col70"><p class="t-left"><em>Way of Wisdom: Essays in Honor of Bruce K. Waltke</em>. Edited by J. I. Packer and Sven K. Soderlund. Grand Rapids: Zondervan, 2000</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ZAH</em></p></td>
<td class="col70"><p class="t-left"><em>Zeitschrift für Althebräistik</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ZAW</em></p></td>
<td class="col70"><p class="t-left"><em>Zeitschrift für die alttestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="col25"><p class="t-left">ZBK</p></td>
<td class="col70"><p class="t-left">Zürcher Bibelkommentare</p></td>
</tr>
<tr>
<td class="col25"><p class="t-left"><em>ZTK</em></p></td>
<td class="col70"><p class="t-left"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Abbreviations.vue?683c27f6